<div *ngIf="notifications.length" [@notificationAnimation]="notifications.length">
  <ul class="bc-notification-collector">
    <li *ngFor="let notification of notifications"
        [ngClass]="[getTypeClass(notification), getClosableClass(notification.isClosable)]"
        class="bc-notification-row">
      <div class="bc-notification-text"
           (click)="open(notification)"
           [attr.data-automation-id]="'bc-notification-text'">
        <span class="bc-notification-text-content bc-notification-text-long" title="{{ notification.content | translate }}">
          {{ notification.content | translate }}
        </span>
      </div>
      <svg-icon icon="x"
                *ngIf="notification.isClosable"
                (click)="remove(notification)"
                class="bc-notification-close bc-notification-icon"></svg-icon>
    </li>
  </ul>
</div>
